if (!customElements.get('daddl-localization')) {
  customElements.define(
    'daddl-localization',
    class DaddlLocalization extends HTMLElement {
      constructor() {
        super();
        this.header = document.querySelector('.header-wrapper');
        this.form = this.querySelector('form');
        this.trigger = this.querySelector('[data-daddl-loc-trigger]');
        this.panel = this.querySelector('[data-daddl-loc-panel]');
        this.countryInput = this.querySelector('input[name="country_code"]');
        this.localeInput = this.querySelector('input[name="locale_code"]');
        this.countryFilter = this.querySelector('[data-daddl-loc-country-filter]');
        this.isDrawer = this.classList.contains('daddl-loc--drawer');

        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

        if (this.trigger) {
          this.trigger.addEventListener('click', this.onTriggerClick);
        }

        this.querySelectorAll('[data-daddl-loc-field-btn]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.toggleField(button);
          });
        });

        this.querySelectorAll('[data-daddl-loc-option]').forEach((option) => {
          option.addEventListener('click', (event) => {
            event.preventDefault();
            this.onOptionClick(option);
          });
        });

        if (this.countryFilter) {
          this.countryFilter.addEventListener('input', () => this.filterCountries());
          this.countryFilter.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'ENTER') event.preventDefault();
          });
        }

        this.addEventListener('keydown', this.onKeyDown);
      }

      connectedCallback() {
        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      get isOpen() {
        return this.panel && !this.panel.hasAttribute('hidden');
      }

      onTriggerClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.isOpen ? this.closePanel() : this.openPanel();
      }

      openPanel() {
        if (!this.panel) return;
        this.panel.removeAttribute('hidden');
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
        if (this.hasAttribute('data-prevent-hide') && this.header) {
          this.header.preventHide = true;
        }
      }

      closePanel() {
        if (this.isDrawer) {
          this.closeFields();
          return;
        }
        if (!this.panel) return;
        this.panel.setAttribute('hidden', '');
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
        this.closeFields();
        if (this.hasAttribute('data-prevent-hide') && this.header) {
          this.header.preventHide = false;
        }
      }

      closeFields() {
        this.querySelectorAll('[data-daddl-loc-field-btn]').forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });
        this.querySelectorAll('.daddl-loc__list-wrap').forEach((list) => {
          list.setAttribute('hidden', '');
        });
      }

      toggleField(button) {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        const listId = button.getAttribute('aria-controls');
        const list = listId ? this.querySelector(`#${CSS.escape(listId)}`) : null;

        this.closeFields();

        if (!expanded && list) {
          button.setAttribute('aria-expanded', 'true');
          list.removeAttribute('hidden');
          if (this.countryFilter && list.contains(this.countryFilter)) {
            this.countryFilter.focus();
          }
        }
      }

      onOptionClick(option) {
        const type = option.getAttribute('data-daddl-loc-option');

        if (type === 'country') {
          this.selectCountry(option);
        } else if (type === 'language') {
          this.selectLanguage(option);
        }

        this.closeFields();
      }

      selectCountry(option) {
        const iso = option.dataset.iso;
        const name = option.dataset.name;
        const currency = option.dataset.currency;
        const currencyName = option.dataset.currencyName;

        if (this.countryInput) this.countryInput.value = option.dataset.value;

        this.querySelectorAll('[data-daddl-loc-option="country"]').forEach((item) => {
          const selected = item === option;
          item.toggleAttribute('aria-current', selected);
          const check = item.querySelector('.daddl-loc__check');
          if (check) check.classList.toggle('visibility-hidden', !selected);
        });

        this.syncFlag(this.querySelector('[data-daddl-loc-country-flag]'), iso);
        const countryName = this.querySelector('[data-daddl-loc-country-name]');
        if (countryName) countryName.textContent = name;

        this.syncFlag(this.querySelector('[data-daddl-loc-trigger-flag]'), iso);
        const triggerCurrency = this.querySelector('[data-daddl-loc-trigger-currency]');
        if (triggerCurrency) triggerCurrency.textContent = currency;

        const currencyDisplay = this.querySelector('[data-daddl-loc-currency-display]');
        if (currencyDisplay) {
          currencyDisplay.textContent = currencyName ? `${currency} (${currencyName})` : currency;
        }
      }

      selectLanguage(option) {
        if (this.localeInput) this.localeInput.value = option.dataset.value;

        this.querySelectorAll('[data-daddl-loc-option="language"]').forEach((item) => {
          const selected = item === option;
          item.toggleAttribute('aria-current', selected);
          const check = item.querySelector('.daddl-loc__check');
          if (check) check.classList.toggle('visibility-hidden', !selected);
        });

        const languageName = this.querySelector('[data-daddl-loc-language-name]');
        if (languageName) languageName.textContent = option.dataset.name;

        const triggerLang = this.querySelector('[data-daddl-loc-trigger-lang]');
        if (triggerLang) triggerLang.textContent = option.dataset.isoShort;
      }

      syncFlag(el, iso) {
        if (!el || !iso) return;
        el.className = `fi fi-${iso} localization-form__flag`;
        if (el.hasAttribute('data-daddl-loc-trigger-flag')) {
          el.classList.add('daddl-loc__flag');
        }
      }

      filterCountries() {
        if (!this.countryFilter) return;
        const query = this.countryFilter.value
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();

        this.querySelectorAll('[data-daddl-loc-option="country"]').forEach((item) => {
          const name = (item.dataset.name || '')
            .normalize('NFD')
            .replace(/\p{Diacritic}/gu, '')
            .toLowerCase();
          item.parentElement.classList.toggle('hidden', query.length > 0 && !name.includes(query));
        });
      }

      onDocumentClick(event) {
        if (this.isDrawer) return;
        if (!this.contains(event.target)) this.closePanel();
      }

      onKeyDown(event) {
        const key = event.code.toUpperCase();
        if (key === 'ESCAPE') {
          const openField = this.querySelector('[data-daddl-loc-field-btn][aria-expanded="true"]');
          if (openField) {
            event.preventDefault();
            this.closeFields();
            openField.focus();
            return;
          }
          if (this.isOpen && !this.isDrawer) {
            event.preventDefault();
            this.closePanel();
            if (this.trigger) this.trigger.focus();
          }
        }
      }
    }
  );
}
